import React from 'react';

/**
 * The line icons used across the file-details surface.
 *
 * Hand-rolled rather than pulled from FontAwesome so they inherit `currentColor`
 * and a single 1.75 stroke weight — matching common/InlineBanner, common/Chip and
 * ClosingX, which is what most of the app's chrome already looks like.
 */
const svg = (children, extra = {}) => (props) => (
    <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...extra}
        {...props}
    >
        {children}
    </svg>
);

export const IconDownload = svg(<>
    <path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M4 20h16" />
</>);

export const IconLink = svg(<>
    <path d="M10 13a5 5 0 0 0 7.07 0l2.5-2.5a5 5 0 0 0-7.07-7.07L11.5 4.43" />
    <path d="M14 11a5 5 0 0 0-7.07 0l-2.5 2.5a5 5 0 0 0 7.07 7.07L12.5 19.5" />
</>);

export const IconCheck = svg(<polyline points="20 6 9 17 4 12" />);

export const IconCopy = svg(<>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
</>);

export const IconScissors = svg(<>
    <circle cx="6" cy="6" r="2.5" /><circle cx="6" cy="18" r="2.5" />
    <path d="M8.1 7.5 20 18" /><path d="M8.1 16.5 20 6" />
</>);

export const IconSparkle = svg(<>
    <path d="M12 3.5 13.7 9l5.5 1.7-5.5 1.7L12 18l-1.7-5.6L4.8 10.7 10.3 9z" />
    <path d="M18.5 15.5 19.2 18l2.3.8-2.3.8-.7 2.4-.7-2.4-2.3-.8 2.3-.8z" />
</>);

export const IconRefresh = svg(<>
    <path d="M20 11a8 8 0 0 0-13.6-4.6L3 9" /><path d="M3 4v5h5" />
    <path d="M4 13a8 8 0 0 0 13.6 4.6L21 15" /><path d="M21 20v-5h-5" />
</>);

export const IconImage = svg(<>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="1.6" /><path d="m4 18 5-5 4 4 3-3 4 4" />
</>);

export const IconTrash = svg(<>
    <path d="M4 7h16" /><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    <path d="M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" />
    <path d="M10 11v6M14 11v6" />
</>);

export const IconSearch = svg(<>
    <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
</>);

export const IconPlus = svg(<><path d="M12 5v14" /><path d="M5 12h14" /></>);

export const IconPencil = svg(<>
    <path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17v3z" /><path d="M14.5 6.5l3 3" />
</>);

export const IconChevron = svg(<polyline points="6 9 12 15 18 9" />);

export const IconTag = svg(<>
    <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" /><circle cx="7.5" cy="7.5" r="1.2" />
</>);

export const IconAlert = svg(<>
    <circle cx="12" cy="12" r="9" /><path d="M12 8v5" /><path d="M12 16h.01" />
</>);

export const IconFile = svg(<>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
</>);

export const IconAudio = svg(<>
    <path d="M4 10v4M8 6v12M12 3v18M16 7v10M20 10v4" />
</>);

export const IconVideo = svg(<>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m10 9 5 3-5 3z" />
</>);

export const IconCube = svg(<>
    <path d="M12 2.8 20.5 7v10L12 21.2 3.5 17V7z" />
    <path d="M3.5 7 12 11.4 20.5 7M12 11.4v9.8" />
</>);

export const IconText = svg(<>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h4" />
</>);

/** Category icon for the details header — see utils/fileFacts.kindOf. */
export const KIND_ICONS = {
    audio: IconAudio,
    video: IconVideo,
    image: IconImage,
    model: IconCube,
    text: IconText,
    pdf: IconText,
    file: IconFile,
};
